import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-90daae9a")

_pushScopeId("data-v-90daae9a")
const _hoisted_1 = { class: "recommend-food-view" }
const _hoisted_2 = { class: "recommend-food-view-item-area" }
const _hoisted_3 = { class: "recommend-food-view-message-area" }
const _hoisted_4 = { class: "recommend-food-view-message-title" }
const _hoisted_5 = { class: "recommend-food-view-message-body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RecommendFoodLine = _resolveComponent("RecommendFoodLine")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getList(), (item, index) => {
        return (_openBlock(), _createBlock(_component_RecommendFoodLine, {
          key: index,
          data: item,
          onSelectFood: _ctx.selectFood
        }, null, 8, ["data", "onSelectFood"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getMessageTitle()), 1),
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getMessage()), 1)
    ], 512), [
      [_vShow, _ctx.isShowMessage()]
    ])
  ]))
})